module.exports = __webpack_public_path__ + "img/signup_picture.e75c40e6.png";